import React, { useEffect, useState } from "react"
import { View, StyleSheet, Text } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"

const pad = (n) => String(n).padStart(2, "0")

const computeRemaining = () => {
    const now = new Date()
    const end = new Date()
    end.setHours(23, 59, 59, 999)
    const diff = Math.max(0, end.getTime() - now.getTime())
    const h = Math.floor(diff / 3_600_000)
    const m = Math.floor((diff % 3_600_000) / 60_000)
    const s = Math.floor((diff % 60_000) / 1000)
    return { h, m, s, expired: diff === 0 }
}

/**
 * Décompte H/M/S jusqu'à minuit.
 * Mode "inline" = juste le timer, à composer dans un parent stylé (ex: hero -50%).
 * Mode standalone = bandeau warning autonome.
 */
const TimeUntilMidnightCountdown = ({
    message = "Sécurisez votre tarif -50%",
    inline = false,
}) => {
    const [remaining, setRemaining] = useState(computeRemaining)

    useEffect(() => {
        const id = setInterval(() => setRemaining(computeRemaining()), 1000)
        return () => clearInterval(id)
    }, [])

    if (remaining.expired) return null

    const { h, m, s } = remaining
    const timerStr = `${pad(h)}h ${pad(m)}min ${pad(s)}s`

    if (inline) {
        return (
            <Text style={styles.inlineText}>
                Plus que <Text style={styles.inlineTextBold}>{timerStr}</Text>
            </Text>
        )
    }

    return (
        <View style={styles.container}>
            <FontAwesome5
                name="bolt"
                size={11}
                color={theme.colors.warning}
                solid
            />
            <Text style={styles.text}>
                <Text style={styles.textBold}>{message}</Text> — il reste {timerStr}
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        backgroundColor: theme.colors.warningLight,
        paddingHorizontal: 12,
        paddingVertical: 9,
        borderRadius: 10,
        marginBottom: 12,
    },
    text: {
        flex: 1,
        fontFamily: "Montserrat-Regular",
        fontSize: 12,
        color: theme.colors.warning,
    },
    textBold: {
        fontFamily: "Montserrat-Bold",
    },
    inlineText: {
        fontFamily: "Montserrat-Regular",
        fontSize: 12,
        color: theme.colors.white,
    },
    inlineTextBold: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 13,
    },
})

export default TimeUntilMidnightCountdown
